import Vue from 'vue';
import VueRouter from 'vue-router';
import { initWechat } from '@/utils/wechat';

import routes from './routes';

import { auth } from '@/utils/auth';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  // 微信jssdk初始化
  initWechat();
  auth(to, from, next);
});

export default router;
